import { useQuery } from '@tanstack/react-query';
import { getCoverage } from '../processes.api';

const COVERAGE_QUERY_KEY = ['processes', 'coverage'] as const;

/** Server-state for the event-dekkingsoverzicht page (Story 2.4, FR13/FR14). */
export function useCoverage() {
  return useQuery({
    queryKey: COVERAGE_QUERY_KEY,
    queryFn: () => getCoverage(),
    staleTime: 30 * 1000,
  });
}
